import * as React from 'react';
import { useDebounce } from 'react-use';

import { useCustomRouter } from 'hooks';

import styles from './noAccess.module.scss';

const NoAccess: React.FC = () => {
  const { push } = useCustomRouter();

  useDebounce(
    () => {
      push(`${process.env.NEXT_PUBLIC_ID_URL}`);
    },
    5000,
    [],
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        Вам недоступен Maven Administration.
        <br />
        Вы будете переадресованы на страницу Maven ID
      </h1>
    </div>
  );
};

export default NoAccess;
